import React from "react";
import classNames from "classnames";
import icons from "../../assets/svg/IconSprite.svg";
import "./Icon.scss";

const Icon = props => {
  let iconClasses = classNames("icon", props.className, {
    [`icon--name-${props.name}`]: props.name ? props.name : "search",
    [`icon--orientation-${props.orientation}`]: props.orientation
  });

  let viewBox = "0 0 24 24";
  let width = "24";
  let height = "24";

  if (props.viewBox) {
    viewBox = props.viewBox;
  }
  if (props.width) {
    width = props.width;
  }
  if (props.height) {
    height = props.height;
  }

  if (props.name === 'close') {
    viewBox = "0 0 32 32";
    width = "32";
    height = "32";
  }

  return (
    <svg
      className={iconClasses}
      viewBox={viewBox}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
    >
      <use xlinkHref={icons + "#" + props.name} />
    </svg>
  );
};

export default Icon;
